(function ($) {

    /**
     * Home banner
     **/
    var $slider = $('#js-collections-banner-slider'),
        $prev = $('#js-collections-banner-prev'),
        $next = $('#js-collections-banner-next'),
        $dots = $('#js-collections-banner-dots');

    /**
     * Init slick
     **/
    $slider.slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplaySpeed: 4000,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: $dots,
    });  

    /**
     * Arrows
     **/
    $next.on('click', function() {
        $slider.slick('slickNext');
    });

    $prev.on('click', function() {
        $slider.slick('slickPrev');
    });
    
})(jQuery);